import React from "react";
import styled from "styled-components";

const Container = styled.div`
  max-width: 1080px;
  margin: 0 auto;
`;

export default Container;
